/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { Spin } from 'antd'
import Text from 'src/components/ts-components/Text'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'

/**
 * Props for the AlmostThere component
 * @typedef {Object} AlmostThereProps
 */

/**
 * AlmostThere component for the underage invitation flow
 * Displays a loading screen while the profile is being set up
 *
 * @param {AlmostThereProps} props - Component props
 * @returns {JSX.Element} The rendered component
 */
const AlmostThere = () => {
  return (
    <div css={containerStyle}>
      <Text
        variant='heading2'
        weight='semiBold'
        color={colors.NEUTRAL_0}
        style={'text-align: center;'}
      >
        {capitalizeWords('Almost There!')}
      </Text>
      <Text
        variant='paragraphMedium'
        weight='regular'
        color={colors.NEUTRAL_50}
        style={'text-align: center;'}
      >
        We are setting up your profile.
      </Text>
      <Spin />
    </div>
  )
}

export default AlmostThere

// ---- styled ----
/*
 * A status screen with nothing to act on, so it centers as a unit: title,
 * then the message, then the spinner beneath them.
 */
const containerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`
